export default __webpack_public_path__ + "assets/pressure-low.5565c615.svg";